import {
    SERVICE_ENDPOINTS_TAG,
    begatewayEndpointsApi,
    routeEndpointsArgs,
    serviceEndpointsArgs,
} from '@/store/api/begateway/begateway.endpoints.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeGatewayEndpoint, TypeGatewayEndpointDetail } from '@/types/begateway/types.begateway.endpoint';
import { dropById } from '@/store/api/base/api.cache';

const listItem = (endpoint: TypeGatewayEndpoint | TypeGatewayEndpointDetail): TypeGatewayEndpoint => {
    const item = { ...endpoint } as Partial<TypeGatewayEndpointDetail>;
    delete item.serviceLimit;
    return item as TypeGatewayEndpoint;
};

export const writeEndpoint = (dispatch: TypeAppDispatch, endpoint: TypeGatewayEndpoint | TypeGatewayEndpointDetail) => {
    const item = listItem(endpoint);
    const upsert = (list: TypeGatewayEndpoint[]) => {
        const index = list.findIndex((entry) => entry.id === item.id);
        if (index >= 0) list[index] = { ...item, traffic24h: item.traffic24h ?? list[index].traffic24h };
        else list.push(item);
    };

    dispatch(begatewayEndpointsApi.util.updateQueryData('readRouteEndpoints', routeEndpointsArgs(item.route), (draft) => upsert(draft.endpoints)));
    if (item.serviceId) dispatch(begatewayEndpointsApi.util.updateQueryData('readServiceEndpoints', serviceEndpointsArgs(item.serviceId), (draft) => upsert(draft.endpoints)));
    if ('serviceLimit' in endpoint) dispatch(begatewayEndpointsApi.util.updateQueryData('readGatewayEndpoint', endpoint.id, () => endpoint));
    dispatch(begatewayEndpointsApi.util.invalidateTags([{ type: 'GatewayAudit', id: item.route }, { type: 'GatewayAudit', id: item.id }]));
};

export const dropEndpoint = (dispatch: TypeAppDispatch, ref: { id: string; route: string; serviceId: string | null }) => {
    const remove = (list: TypeGatewayEndpoint[]) => {
        dropById(list, ref.id);
    };

    dispatch(begatewayEndpointsApi.util.updateQueryData('readRouteEndpoints', routeEndpointsArgs(ref.route), (draft) => remove(draft.endpoints)));
    if (ref.serviceId) dispatch(begatewayEndpointsApi.util.updateQueryData('readServiceEndpoints', serviceEndpointsArgs(ref.serviceId), (draft) => remove(draft.endpoints)));
    else dispatch(begatewayEndpointsApi.util.invalidateTags([{ type: 'GatewayEndpoint', id: SERVICE_ENDPOINTS_TAG }]));
    dispatch(begatewayEndpointsApi.util.invalidateTags([{ type: 'GatewayAudit', id: ref.route }, { type: 'GatewayAudit', id: ref.id }]));
};
